<template>
  <div id="master" :class="isMOS && status == 'approved' ? 'mosZindex' : ''">
    <div class="backgroundImg">
      <div class="Outline">
        <div
          id="headline"
          :style="[viewPortHeight == -1 ? {} : { height: '65px' }]"
        >
          Barq {{ barqId }}
        </div>

        <div
          class="inside"
          :style="[
            viewPortHeight == -1
              ? {}
              : { height: calcHeight(viewPortHeight) + '%' },
          ]"
        >
          <div class="Deco ml"></div>
          <template v-if="isMOS && status == 'approved'">
            <Mosaic :barqId="barqId" :sprache="sprache" />
          </template>
          <template v-else>
            <img :src="loadBarq(barqId)" alt="barq" />
          </template>

          <div class="Deco mr"></div>
        </div>
        <div class="bottom">
          <div class="DecoText left">Deco</div>
          <div class="Signature">
            <div class="sigText">Signature</div>
            <div class="sigBlock"></div>
          </div>
          <div class="DecoText right">Deco</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mosaic from "./Mosaic";

export default {
  name: "Barqdisplay",
  components: {
    Mosaic,
  },
  props: {
    isMOS: {
      type: Boolean,
      default: () => false,
    },
    status: {
      type: String,
      default: () => "non",
    },
    sprache: {
      type: String,
      default: () => "english",
    },
    barqId: {
      type: String,
      default: () => "",
    },
    viewPortHeight: {
      type: Number,
      default: () => -1,
    },
  },
  data() {
    return {
      height: 0,
    };
  },

  methods: {
    loadBarq(barqId) {
      // console.log("Barqdisplay: " + barqId);
      const splitId = barqId.split("#");
      if (splitId[0] === "MOS") {
        //check if MOS and set splitId = minimal code change
        splitId[1] = "MOS";
      }
      if (splitId[1].length < 3) return "";
      let img = "";
      try {
        img = require("../assets/Barqs/" + splitId[1] + ".png");
      } catch (e) {
        console.log("img not found");
      }
      return img;
    },
    calcHeight(h) {
      if (h <= 560) return 73;
      if (h <= 600) return 76;
      if (h <= 645) return 78;
      return 80;
    },
  },
  created() {
    console.log("BARQdisplay CREATED!");
  },
};
</script>

<style scoped>
.mosZindex {
  z-index: 1;
}

#container {
  max-width: 450px;
}

.left {
  left: 4px;
}

.right {
  right: 4px;
}

.DecoText {
  font-size: 13px;
  position: absolute;
  top: 2px;
}

/* .Signature {
  margin-left: 33%;
  line-height: 44px;
} */

.ml {
  left: 5px;
}

.mr {
  right: 5px;
}

/* .Signature > p:after {
  content: "";
  display: block;
  position: absolute;
  top: 6px;
  left: 226px;
  right: 0px;
  bottom: 0px;
  width: 158px;
  height: 33px;
  background-color: white;
  pointer-events: none;
} */

.Signature {
  position: absolute;
  right: 52px;
  display: flex;
  align-items: center;
  top: 10px;
}

.sigText {
  margin-right: 10px;
}

.sigBlock {
  width: 158px;
  height: 33px;
  background-color: white;
  pointer-events: none;
}

#headline {
  text-align: center;
  line-height: min(8.5vh, 65px);
  font-size: min(5.5vh, 50px);
}

.backgroundImg {
  width: calc(100% - 4px);
  position: absolute;
  z-index: -1;
  aspect-ratio: 1;
  top: 50%;
  transform: translate(0, -50%);
}

.inside {
  display: flex;
  height: 80%;
  position: relative;
  justify-content: space-between;
}

.bottom {
  margin-top: 0px;
  height: 65px;
  position: relative;
}

.Deco {
  height: 100%;
  width: 32px;
  background-color: white;
  /* position: absolute; */
}

.Outline:before {
  border: 2px solid #fff;
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-radius: 70px;
  pointer-events: none;
}

.Outline {
  padding: 0 10px;
  border: 2px solid var(--barq-orange);
  border-radius: 70px;
  position: relative;
  background: var(--barq-orange);
  color: white;
  height: 100%;
}

#master {
  position: relative;
  height: 100%;
}

@media only screen and (max-height: 645px) {
  .inside {
    height: 78%;
  }
}

@media only screen and (max-height: 600px) {
  .inside {
    height: 76%;
  }
}

@media only screen and (max-height: 560px) {
  .inside {
    height: 73%;
  }
}
</style>
